<template lang="html">
    <div class="container-fluid p-5">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="row">
            <div class="col-md-12">
                <div class="card agent-member-card-responsive">
                    <div class="card-header">
                        Daily Report List
                    </div>
                    <div class="card-body">
                         <div class="row" >
                            <div class="col-md-12">
                                <div class="row search-form">
                                    <div class="col-md-3 mt-1">
                                        <b-form-datepicker
                                            v-model="filter.from"
                                            locale="en-CA"
                                            :value-as-date="false"
                                            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                                            class="w-100"
                                            :today-button="true"
                                            :reset-button="true"
                                            :close-button="true"
                                            label-today-button="Today"
                                            label-reset-button="Clear"
                                            label-close-button="Close"
                                            placeholder="YYYY-MM-DD"
                                        />
                                    </div>
                                     <div class="col-md-3 mt-1">
                                        <b-form-datepicker
                                            v-model="filter.to"
                                            locale="en-CA"
                                            :value-as-date="false"
                                            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                                            class="w-100"
                                            :today-button="true"
                                            :reset-button="true"
                                            :close-button="true"
                                            label-today-button="Today"
                                            label-reset-button="Clear"
                                            label-close-button="Close"
                                            placeholder="YYYY-MM-DD"
                                        />
                                    </div>
                                    <div class="col-md-3 mt-1">
                                        <button class="btn btn-primary mr-1 fbutton" @click="search()"><i class="fas fa-search"></i> Search</button>
                                        <button class="btn btn-info fbutton" @click="reset()"><i class="fas fa-sync"></i> Refresh</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mt-4">
                            <table class="common-table">
                                <thead>
                                    <tr>
                                        <th rowspan="2" class="text-center align-middle">Date</th>
                                        <th rowspan="2" class="text-center">Bet</th>
                                        <th colspan="2" class="text-center">Member</th>
                                        <th colspan="1" class="text-center">Agent</th>
                                        <th colspan="2" class="text-center">Master</th>
                                    </tr>
                                    <tr>
                                        <!-- <th class="text-center">Bet</th>
                                        <th class="text-center">Commission</th>
                                        <th class="text-center">W/L</th> -->
                                        <th class="text-center">Return</th>
                                        <th class="text-center">W/L</th>
                                        <th class="text-center">Comm</th>
                                        <!-- <th class="text-center">W/L</th> -->
                                        <th class="text-center">Comm</th>
                                        <th class="text-center">W/L</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(data, index) in dataList" :key="data.id">
                                        <td class="text-center">
                                            <a href="#" @click="toMemberReport(data)">{{ data.day }}</a>
                                        </td>
                                        <!-- <td class="text-center">{{ data.total_bet_amount }}</td>
                                        <td class="text-center">{{ data.total_master_commission }}</td>
                                        <td class="text-center">{{ data.total_master_win_or_lose }}</td> -->
                                        <td class="text-center">{{ data.total_bet_amount }}</td>
                                        <td class="text-center member-color">{{ data.total_returned_amount }}</td>
                                        <td class="text-center member-color">{{ data.total_member_win_or_lose }}</td>
                                        <td class="text-center agent-color">{{ data.total_agent_commission }}</td>
                                        <!-- <td class="text-center">{{ data.total_agent_commission }}</td> -->
                                        <td class="text-center master-color">{{ data.total_master_commission }}</td>
                                        <td class="text-center master-color">{{ data.total_master_win_or_lose }}</td>
                                    </tr>
                                    <tr v-if="dataList.length > 0" class="table-summary font-weight-bold text-white" style="background-color: #4e8889;">
                                        <td class="text-center" >
                                           TOTAL
                                        </td>
                                        <td class="text-center">{{ summaryData.total_bet_amount }}</td>
                                        <td class="text-center">{{ summaryData.total_returned_amount }}</td>
                                        <td class="text-center">{{ summaryData.total_member_win_or_lose }}</td>
                                        <td class="text-center">{{ summaryData.total_agent_commission }}</td>
                                        <!-- <td class="text-center">{{ summaryData.total_agent_commission }}</td> -->
                                        <td class="text-center">{{ summaryData.total_master_commission }}</td>
                                        <td class="text-center">{{ summaryData.total_master_win_or_lose }}</td>
                                    </tr>
                                    <tr v-if="dataList.length === 0">
                                        <td :colspan="8" class="text-center">Empty List</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="table-pagination-minimal">
                            <div class="table-pagination-row">
                                <div v-if="dataList.length > 0 " class="table-info-minimal left-align">
                                    Showing <span>{{metaData.from}}</span> to <span>{{metaData.to}}</span> of <span>{{metaData.total}}</span> entries
                                </div>
                                <nav class="pagination-minimal">
                                    <ul>
                                        <li :class="{ 'disabled': metaData.prev_page_url === null }">
                                            <button @click.prevent="next(metaData.current_page-1)" :disabled="metaData.prev_page_url === null">
                                                <i class="fas fa-angle-left"></i>
                                            </button>
                                        </li>
                                        <li v-for="page in metaData.last_page" :key="page"
                                            :class="{ 'active':metaData.current_page === page }"
                                            v-if="Math.abs(page - metaData.current_page) < 3 || page == metaData.last_page || page == 1">
                                            <button @click.prevent="next(page)">{{ page }}</button>
                                        </li>
                                        <li :class="{ 'disabled': metaData.current_page === metaData.last_page }">
                                            <button @click.prevent="next(metaData.current_page+1)" :disabled="metaData.current_page === metaData.last_page">
                                                <i class="fas fa-angle-right"></i>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div> <!-- close card-body -->
                </div> <!-- close card -->
            </div> <!-- close col-md-12 -->
        </div> <!-- close row -->
    </div> <!-- close container-fluid -->
</template>

<script lang="js">
 import {
     mapState,
     mapActions
 } from 'vuex'
 import env from '../../enviorments'
 import Loading from 'vue-loading-overlay'
 import { BFormDatepicker } from 'bootstrap-vue'
 import 'vue-loading-overlay/dist/vue-loading.css';
 import EmptyTableRow from "@/components/EmptyTableRow.vue";
 export default {
     name: 'dailyReportList',
     metaInfo: {
         title: "Daily Report List",
         titleTemplate: "%s ← BXB",
     },
     components: {
         Loading,
         BFormDatepicker,
         EmptyTableRow
     },
     data() {
         return {
             env,
             isLoading: false,
             fullPage: true,
             alert: "",
             id: '',
             userName: '',
             status: '',
             dataList: [],
             permissions: '',
             summaryData: {},
             columns: {
                 "day": "Day",
                 "total_deposit": "Total Deposit",
                 "total_withdraw": "Total Withdraw",
                 "net_deposit": "Net Deposit"
             },
             filter: {
                 page: 1,
                 orderBy: "asc",
                 sortKey: "created_at",
                 limit: 10,
                 from: new Date().toISOString().slice(0, 10),
                 to: new Date().toISOString().slice(0, 10),
                 agPage: "",
                 agOrderBy: "",
                 agSortKey: "",
                 agLimit: "",
                 agFrom: "",
                 agTo: "",
                 redirect: "",
                 rePage: "",
                 reOrderBy: "",
                 reSortKey: "",
                 reLimit: "",
                 reFrom: "",
                 reTo: "",
             },
             metaData: {
                 last_page: null,
                 current_page: 1,
                 from: null,
                 to: null,
                 total: null,
                 prev_page_url: null
             }
         }
     },
     watch: {
     '$route' (to, from) {
         this.fetchData()
     }
 },
     computed: {},
 methods: {
         ...mapActions({
             agentDailyReportListAction: 'agentDailyReportListAction',
             totalAgentDailySummaryAction: 'totalAgentDailySummaryAction',

         }),
         sortBy(column) {
             this.filter.sortKey = column
             if (this.filter.sortKey == column) {
                 if (this.filter.orderBy == "asc") {
                     this.filter.orderBy = "desc"
                 } else if (this.filter.orderBy == "desc") {
                     this.filter.orderBy = "asc"
                 }
             } else {
                 this.filter.orderBy = "asc"
             }
             this.fetchData()
         },
         async getPaymentMethod(){
	await this.paymentMethodAction().then(res => {
		this.paymentMethod = res.data
		this.isLoading = false
	}).catch(err => this.isLoading = true)
},
         async search() {
             this.filter.page = 1
             this.fetchData()
             this.$refs['my-modal'].hide()
         },
         async fetchData() {
             this.isLoading = true
             let option = this.filter
             console.log(option)
             await this.agentDailyReportListAction({
                 ...option
             }).then(res => {
                 if (res.success == true) {
                     this.dataList = res.data.data
                     this.metaData.last_page = res.data.meta.lastPage
                     this.metaData.current_page = res.data.meta.currentPage
                     this.metaData.prev_page_url = res.data.meta.prevPageUrl
                     this.metaData.from = res.data.meta.from
                     this.metaData.to = res.data.meta.to
                     this.metaData.total = res.data.meta.total
                     this.$router.replace({
                         path: 'agent-daily-report-list',
                         query: {
                             page: this.filter.page,
                             orderBy: this.filter.orderBy,
                             sortKey: this.filter.sortKey,
                             from: this.filter.from,
                             to: this.filter.to
                         }
                     }).catch(()=>{})
                     this.fetchSummary()
                     this.isLoading = false;
                 }
             }).catch(err => this.isLoading = true)
         },
         async fetchSummary() {
             this.isLoading = true
             let option = this.filter
             console.log(option)
             await this.totalAgentDailySummaryAction({
                 ...option
             }).then(res => {
                 if (res.success == true) {
                     this.summaryData = res.data
                     this.isLoading = false;
                 }
             }).catch(err => this.isLoading = true)
         },
         next: function (page) {
             this.filter.page = page
             this.fetchData();
         },
         reset(){
             this.$router.replace({
                 path: 'agent-daily-report-list',
                 query: {
                     page: 1,
                     orderBy: 'desc',
                     sortKey: 'created_at'
                 }
             }).catch(()=>{})
             this.$router.go()
         },
         editData(data) {
             this.id = data.id
             this.userName = data.user_name
             this.status = data.status
         },
         toMemberReport(data) {
             this.$router.replace({
                 path: 'agent-member-report-list',
                 query: {
                     page: 1,
                     orderBy: 'desc',
                     sortKey: 'created_at',
                     limit: 10,
                     from: data.day,
                     to: data.day,
                     redirect: "daily",
                     rePage: this.filter.page,
                     reOrderBy: this.filter.orderBy,
                     reSortKey: this.filter.sortKey,
                     reLimit: this.filter.limit,
                     reFrom: this.filter.from,
                     reTo: this.filter.to
                 } }).catch(()=>{})
         },
         checkPermission: function (key) {
             if(key in this.permissions){
                 return true
             }else{
                 return false
             }
         }

     },
     async mounted() {
         let user = JSON.parse(window.localStorage.getItem('user'))
         this.permissions = user.permissions
         this.filter.page = this.$route.query.page
         this.filter.orderBy = this.$route.query.orderBy
         this.filter.sortKey = this.$route.query.sortKey
         if(this.$route.query.from){
             this.filter.from = this.$route.query.from
         }
         if(this.$route.query.to){
             this.filter.to = this.$route.query.to
         }
         await this.fetchData()
         await this.fetchSummary()
     }
 }
</script>
<style scoped lang="scss">
/* Large commission modal custom width */
.commission-modal-lg .modal-dialog {
  max-width: 900px;
}
.badge-16 {
  font-size: 16px;
}
</style>
